import(/* webpackMode: "eager" */ "/app/landing/src/app/companies/page.tsx");
